import { appstr } from "@coreapp/utils/appstr";
import { sanitizeBlockedValue } from "@coreapp/utils/FormatFieldValue";
import { Text } from "@theorgchartdev/storybook";
import React from "react";

export const PositionText = ({
  templateStr,
  positionObject,
  positionTitle,
  positionID,
  textProps
}) => {
  const GetPositionDetails = () => {
    if (positionObject) {
      return {
        title: sanitizeBlockedValue(positionObject.SmartGetFieldValue("Position Title")),
        id: sanitizeBlockedValue(positionObject.SmartGetFieldValue("PositionID"))
      };
    }

    return {
      title: sanitizeBlockedValue(positionTitle, ""),
      id: sanitizeBlockedValue(positionID, "")
    };
  };

  const getDynamicTextProps = () => {
    const template = appstr(templateStr);
    const replaceDict = GetPositionDetails();
    const formatConfig = {
      title: { type: "bold" },
      id: { type: "bold" }
    };

    return {
      template,
      replaceDict,
      formatConfig
    };
  };

  return (
    <Text dynamic={{ ...getDynamicTextProps() }} size={"small"} {...textProps}>
      {appstr(templateStr, GetPositionDetails())}
    </Text>
  );
};
